import ConfirmPhotoUpload from "../views/Users/ConfirmUpload";

import {
    Person,
} from "@material-ui/icons";

const confirmUploadPhotoRoutes = [
    {
        path: "/confirm-upload-photo",
        sidebarName: "ConfirmPhotoUpload",
        navbarName: "ConfirmPhotoUpload",
        icon: Person,
        component: ConfirmPhotoUpload
    },
    { redirect: false, path: "/", to: "/confirm-upload-photo", navbarName: "Redirect" }
];

export default confirmUploadPhotoRoutes;



// WEBPACK FOOTER //
// ./src/routes/confirm-upload-photo.jsx